import { Link } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';
import PropTypes from 'prop-types';

import { assignmentTypeEnum } from '../../../../../utils/dataStatus';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './ViewSdsDetails.module.scss';

/** @param {{ idSolicitud: number, tipoAsignacion: number }} props */
const ViewSdsDetails = ({ idSolicitud, tipoAsignacion }) => {
  const path =
    tipoAsignacion !== assignmentTypeEnum.Mensualizada
      ? `/detail/${idSolicitud}`
      : `/detailmonthly/${idSolicitud}`;

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Ir a la solicitud">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <Link
          aria-label="Ver datos de la solicitud"
          className={styles.btn}
          rel="noopener noreferrer"
          target="_blank"
          to={path}
        >
          <FaExternalLinkAlt className={styles['view-details']} />
        </Link>
      </div>
    </ComponentWithTooltip>
  );
};

export default ViewSdsDetails;

ViewSdsDetails.propTypes = {
  idSolicitud: PropTypes.number.isRequired,
  tipoAsignacion: PropTypes.number.isRequired
};
